<script>
    import CRUD from './CRUD.svelte';
    import { t } from 'svelte-i18n';
  import { fetchMonedas, saveMoneda, removeMoneda, searchMonedas, subscribeToMonedas, unsubscribeFromMonedas } from '../controllers/monedaController.js';

  let monedaColumns = [
    { label: 'Código', field: 'codigo', type: 'text'  },
    { label: 'Descripción', field: 'descrip', type: 'text'  },
    { label: 'Símbolo', field: 'simbolo', type: 'text'  },
    { label: 'Tipo de cambio', field: 'tipo_cambio', type: 'text'  },
    { label: 'Estado', field: 'sta', type: 'bool'  },
    { label: 'Por defecto', field: 'default', type: 'bool'  },
  ];

  let newMoneda = {
    codigo: '',
    descrip: '',
    simbolo: '',
    tipo_cambio: 1,
    sta: true,
    default: false,
  };

  let editColumns = [
      { label: 'Código', key: 'codigo', type: 'text', required: true },
      { label: 'Descripción', key: 'descrip', type: 'text', required: true },
      { label: 'Símbolo', key: 'simbolo', type: 'text', required: true },
      { label: 'Tipo de cambio', key: 'tipo_cambio', type: 'number', step: '0.01', required: true }, 
      { label: 'Estado', key: 'sta', type: 'checkbox' },
      { label: 'Por defecto', key: 'default', type: 'checkbox' },
  ]; 

</script>

<CRUD 
  title={$t('entities.monedas')}
  entityName="moneda"
  newEntity={newMoneda}
  columns={monedaColumns}
  fetchEntities={fetchMonedas}
  saveEntity={saveMoneda}
  removeEntity={removeMoneda}
  searchEntities={searchMonedas}
  subscribeToChanges={subscribeToMonedas}
  unsubscribeFromChanges={unsubscribeFromMonedas}
  editColumns={editColumns}
/>
